import { Modal, ModalBody, ModalHeader } from "flowbite-react"
import VoiceSettings from "./settings/VoiceSettings"

export default function CallerSettingsModal({
  show,
  setShow,
  reload
}: {
  show: boolean
  setShow: (show: boolean) => void
  reload: () => void
}) {
  const onClose = () => {
    setShow(false)
    reload()
  }

  return (
    <Modal show={show} onClose={onClose} size="4xl" className="pt-safe">
      <ModalHeader className="bg-linear-to-r from-purple-600 to-indigo-600 text-white p-8 rounded-t-lg">
        <div className="text-white text-xl font-bold text-center">Voice & AI Settings</div>
      </ModalHeader>
      <ModalBody>
        <div className="space-y-6">
          <VoiceSettings />
        </div>
      </ModalBody>
    </Modal>
  )
}
